export enum CustomPDFReportNumRequiredSecurities {
    ONE = 1,
    TWO = 2,
    THREE_PLUS = 3,
}
